import { all } from "redux-saga/effects";
import notification from "./notificationMiddleware";
import auth from "./authMiddleware";
import video from "./videoMiddlerware";
import videos from "./videosMiddlerware";

export default function* rootMiddleware() {
  yield all([notification(), auth(), video(), videos()]);
}



// WEBPACK FOOTER //
// ./src/redux/middleware/index.js